import { put, call, takeLatest } from "redux-saga/effects";
import * as API from "us.collection.admin/services";
import * as Actions from "us.collection.admin/actions";
import { PowerBIDashboard } from "us.collection.admin/constants/Actions";

const powerBIService = API.powerBIDashboard;
const { reports } = Actions.powerBIDashboard;

const PowerBIDashboardSaga = {
  reports: {
    get: function* () {
      try {
        const { data, status } = yield call(powerBIService.reports.get);
        if (status === 200) {
          yield put(reports.success(data));
        } else {
          yield put(reports.fail(data));
        }
      } catch (error) {
        yield put(reports.fail(new Error()));
      }
    },
  },
};

export default [
  takeLatest(
    PowerBIDashboard.GET_POWERBI_REPORTS,
    PowerBIDashboardSaga.reports.get
  ),
];
